<template>
  <div
    class="card"
    :class="{single: single, grow: !single && $store.state.choosingReview !== book.id, highlight: book.status === 'ChangesRequested'}"
    @click="cardClicked"
  >
    <div class="content">
      <div class="cover">
        <img class="cover-image" :src="imageUrl" v-if="book.cover_file_url" />
        <!-- <i v-if="book.status === 'ChangesRequested'" class="material-icons changes-needed-icon">announcement</i> -->
      </div>
      <div class="title">
        <div class="title-text">{{ book.title }}</div>
        <status :book="book"></status>
        <div class="clearfix"></div>
        <div class="metrics-container">
          <metrics :book="book"></metrics>
        </div>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in">
      <get-reviewed
        :book="book"
        v-on:book-upped="refreshBook"
        v-if="$store.state.choosingReview === book.id"
      ></get-reviewed>
    </transition>
  </div>
</template>

<script>
import Status from "./Status";
import Metrics from "./Metrics";
import GetReviewed from "./GetReviewed";
import { mapGetters } from "vuex";

export default {
  name: "Card",
  props: ["book", "single", "locked"],
  components: { Status, Metrics, GetReviewed },
  data: function() {
    return {};
  },
  computed: {
    imageUrl: function() {
      return process.env.VUE_APP_S3_PATH + this.book.cover_file_url;
    },
    route: function() {
      if (this.book.status === "Editing") {
        return "edit/" + this.book.id;
      } else {
        return this.book.id;
      }
    },
    ...mapGetters({
      choosingReview: "choosingReview"
    })
  },
  methods: {
    refreshBook() {},
    cardClicked() {
      if (
        !this.single &&
        !this.locked &&
        this.$store.state.choosingReview !== this.book.id
      ) {
        this.$router.push("/books/" + this.route);
      }
    }
  },
  created() {
    //console.log("env", process.env);
    // console.log("book", this.book);
  }
};
</script>

<style lang="scss" scoped>
.card {
  min-height: 184px;
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 0 0 18px 0;
  padding: 12px 0;
  padding-bottom: 0 !important;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}
.highlight {
  box-shadow: 0px 1px 0.5rem $color-red;
}


.single {
  zoom: 1.2;
  box-shadow: none !important;
  border: 0 !important;
  padding: 0 0 8px 0 !important;
  margin: 0px 0 0 0 !important;

  .content {
    padding: 0 !important;
  }

  .title-text {
    padding-right: 1em;
    font-size: 20pt !important;
  }

  .cover {
    min-width: 126px;
    flex-basis: 126px;
    flex-grow: 0;
    position: relative;
  }

  .cover-image {
    width: 104px;
    margin: 0 2px;
    //box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2);
  }
  .changes-needed-icon {
    position: absolute;
    top: 10%;
    color: red;
    // left: 0;
    // height: 20%;
    // width: 20%;
  }

  .metrics-container {
    padding-bottom: 6px;
  }
}

.grow {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.content {
  display: flex;
  padding: 8px;
}

.cover {
  flex-basis: 140px;
  min-width: 140px;
  flex-grow: 0;
}

.cover-image {
  width: 100px;
  margin: 0 18px;
  border-radius: 3px;
  //-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2);
}

.title {
  flex-grow: 1;
  letter-spacing: 0 !important;
  display: flex;
  flex-direction: column;
}

.metrics-container {
  padding-bottom: 5px;
  margin-top: auto;
}

.title-text {
  padding-top: 8px;
  padding-bottom: 4px;
  padding-right: 20px;
  line-height: 1.15em;
  font-size: 20pt;
  font-weight: 700;
  color: $color-blue;
  letter-spacing: 0 !important;
  font-family: "Source Sans Pro";
}

@media (max-width: 1024px) {
  .card {
    margin-bottom: 0px !important;
    min-height: 140px;

    .title-text {
      font-size: 17pt !important;
      padding-right: 0 !important;
    }
  }

  .single {
    zoom: 1 !important;

    .title-text {
      font-size: 17pt !important;
      padding-right: 0 !important;
    }

    .cover-image {
      width: 90px !important;
      margin: 0 0px !important;
      margin-left: 2px !important;
      margin-top: 2px !important;
    }
  }

  .cover {
    flex-basis: 110px !important;
    min-width: 110px !important;
    flex-grow: 0 !important;
  }

  .cover-image {
    width: 80px !important;
    margin: 0 11px !important;
    margin-top: 2px !important;
  }
}
</style>